export const localizedPathComponents = {
  en: {
    trail: 'trail',
    parks: 'parks',
    cities: 'cities',
    states: 'states',
    'national-parks': 'national-parks',
    'state-parks': 'state-parks',
    'local-parks': 'local-parks'
  },
  'da-dk': {
    trail: 'rute',
    parks: 'parker',
    cities: 'cities',
    states: 'states',
    'national-parks': 'national-parks',
    'state-parks': 'state-parks',
    'local-parks': 'local-parks'
  },
  de: {
    trail: 'route',
    parks: 'parks',
    cities: 'staedte',
    states: 'staaten',
    'national-parks': 'nationalparks',
    'state-parks': 'naturparks',
    'local-parks': 'regionale-parks'
  },
  'en-gb': {
    trail: 'trail',
    parks: 'parks',
    cities: 'cities',
    states: 'states',
    'national-parks': 'national-parks',
    'state-parks': 'state-parks',
    'local-parks': 'local-parks'
  },
  es: {
    trail: 'ruta',
    parks: 'parques',
    cities: 'ciudades',
    states: 'estados',
    'national-parks': 'parques-nacionales',
    'state-parks': 'parques-naturales',
    'local-parks': 'parques-locales'
  },
  'es-mx': {
    trail: 'ruta',
    parks: 'parques',
    cities: 'ciudades',
    states: 'estados',
    'national-parks': 'parques-nacionales',
    'state-parks': 'parques-naturales',
    'local-parks': 'parques-locales'
  },
  fr: {
    trail: 'randonnee',
    parks: 'parcs',
    cities: 'villes',
    states: 'etats',
    'national-parks': 'parcs-nationaux',
    'state-parks': 'parcs-naturels-regionaux',
    'local-parks': 'parcs-locaux'
  },
  'it-it': {
    trail: 'sentiero',
    parks: 'parchi',
    cities: 'cities',
    states: 'states',
    'national-parks': 'national-parks',
    'state-parks': 'state-parks',
    'local-parks': 'local-parks'
  },
  'nl-nl': {
    trail: 'wandelpad',
    parks: 'parken',
    cities: 'cities',
    states: 'states',
    'national-parks': 'national-parks',
    'state-parks': 'state-parks',
    'local-parks': 'local-parks'
  },
  'nb-no': {
    trail: 'sti',
    parks: 'parker',
    cities: 'cities',
    states: 'states',
    'national-parks': 'national-parks',
    'state-parks': 'state-parks',
    'local-parks': 'local-parks'
  },
  'pl-pl': {
    trail: 'szlak',
    parks: 'parki',
    cities: 'cities',
    states: 'states',
    'national-parks': 'national-parks',
    'state-parks': 'state-parks',
    'local-parks': 'local-parks'
  },
  'pt-br': {
    trail: 'trilha',
    parks: 'parques',
    cities: 'cities',
    states: 'states',
    'national-parks': 'national-parks',
    'state-parks': 'state-parks',
    'local-parks': 'local-parks'
  },
  'pt-pt': {
    trail: 'trilho',
    parks: 'parques',
    cities: 'cities',
    states: 'states',
    'national-parks': 'national-parks',
    'state-parks': 'state-parks',
    'local-parks': 'local-parks'
  },
  'sv-se': {
    trail: 'led',
    parks: 'parker',
    cities: 'cities',
    states: 'states',
    'national-parks': 'national-parks',
    'state-parks': 'state-parks',
    'local-parks': 'local-parks'
  }
};

export const allLocales = Object.keys(localizedPathComponents);
